/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiserviceMelcoModelsDesign,
    ApiserviceMelcoModelsDesignFromJSON,
    ApiserviceMelcoModelsDesignToJSON,
    ApiserviceMelcoModelsError,
    ApiserviceMelcoModelsErrorFromJSON,
    ApiserviceMelcoModelsErrorToJSON,
} from '../models';

export interface AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeDownloadRequest {
    newWidth?: number;
    newHeight?: number;
    imageFile?: Blob;
}

export interface AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeMetadataRequest {
    newWidth?: number;
    newHeight?: number;
    imageFile?: Blob;
}

export interface AutoDigitizeApiUserDesignsDesignEditorAutoDigitizePreviewRequest {
    newWidth?: number;
    newHeight?: number;
    imageFile?: Blob;
}

/**
 * 
 */
export class AutoDigitizeApi extends runtime.BaseAPI {

    /**
     */
    async userDesignsDesignEditorAutoDigitizeDownloadRaw(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.newWidth !== undefined) {
            queryParameters['new_width'] = requestParameters.newWidth;
        }

        if (requestParameters.newHeight !== undefined) {
            queryParameters['new_height'] = requestParameters.newHeight;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.imageFile !== undefined) {
            formParams.append('image_file', requestParameters.imageFile as any);
        }

        const response = await this.request({
            path: `/design-editor/digitize/download`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorAutoDigitizeDownload(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeDownloadRequest): Promise<Blob> {
        const response = await this.userDesignsDesignEditorAutoDigitizeDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorAutoDigitizeMetadataRaw(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeMetadataRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDesign>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.newWidth !== undefined) {
            queryParameters['new_width'] = requestParameters.newWidth;
        }

        if (requestParameters.newHeight !== undefined) {
            queryParameters['new_height'] = requestParameters.newHeight;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.imageFile !== undefined) {
            formParams.append('image_file', requestParameters.imageFile as any);
        }

        const response = await this.request({
            path: `/design-editor/digitize/metadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorAutoDigitizeMetadata(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizeMetadataRequest): Promise<ApiserviceMelcoModelsDesign> {
        const response = await this.userDesignsDesignEditorAutoDigitizeMetadataRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorAutoDigitizePreviewRaw(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizePreviewRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.newWidth !== undefined) {
            queryParameters['new_width'] = requestParameters.newWidth;
        }

        if (requestParameters.newHeight !== undefined) {
            queryParameters['new_height'] = requestParameters.newHeight;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.imageFile !== undefined) {
            formParams.append('image_file', requestParameters.imageFile as any);
        }

        const response = await this.request({
            path: `/design-editor/digitize/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorAutoDigitizePreview(requestParameters: AutoDigitizeApiUserDesignsDesignEditorAutoDigitizePreviewRequest): Promise<Blob> {
        const response = await this.userDesignsDesignEditorAutoDigitizePreviewRaw(requestParameters);
        return await response.value();
    }

}
